import { render, staticRenderFns } from "./privSchoolArea.vue?vue&type=template&id=441593ea&scoped=true&"
import script from "./privSchoolArea.vue?vue&type=script&lang=js&"
export * from "./privSchoolArea.vue?vue&type=script&lang=js&"
import style0 from "./privSchoolArea.vue?vue&type=style&index=0&id=441593ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441593ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
